import Slider from 'react-slick';
import React, { useMemo, useState } from 'react';
import { SkeletonGroup } from '@shared/components/Skeleton';
import { StyledSliderContainer, styles } from './HeroSlider.styles';
import { Hero, HeroSkeleton, HeroDataProps, getTextColor } from './components/Hero/Hero';
// react-click having issue with ssr - https://github.com/akiran/react-slick/issues/1837#issuecomment-1028174830
// So instead of replace whole package used css to fix issue
import './css/slick.css';
import './css/slick-theme.css';
import { StyleSystemProps } from '@withjoy/joykit';

interface SliderProps {
  dots?: boolean;
  arrows?: boolean;
  autoplay?: boolean;
  pauseOnHover?: boolean;
  speed?: number;
  slidesToShow?: number;
  slidesToScroll?: number;
  autoplaySpeed?: number;
  useTransform?: boolean;
}

export type HeroSliderProps = SliderProps & {
  loading: boolean;
  items: HeroDataProps[];
  onViewCollectionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: string) => void;
  onOpenVideoPlayer?: (id: string) => void;
  onChangeSliderItem?: (id: string) => void;
  customWrapperStyles?: StyleSystemProps;
};

export const HeroSlider: React.FC<HeroSliderProps> = ({ loading, items, onChangeSliderItem, onViewCollectionClick, onOpenVideoPlayer, ...sliderProps }) => {
  const {
    dots = true,
    arrows = false,
    autoplay = true,
    pauseOnHover = false,
    speed = 1000,
    slidesToShow = 1,
    slidesToScroll = 1,
    autoplaySpeed = 10000,
    useTransform = false,
    customWrapperStyles,
  } = sliderProps;

  const [sliderIndex, setSliderIndex] = useState(() => 0);
  const dotsColor = useMemo(() => (items.length ? getTextColor(items[sliderIndex].textCustomColorValue)[items[sliderIndex].textColorMode].color : undefined), [items, sliderIndex]);

  const sliderSettings = {
    dots,
    arrows,
    autoplay,
    pauseOnHover,
    speed,
    slidesToShow,
    slidesToScroll,
    autoplaySpeed,
    useTransform, // necessary for Safari. If set to true the overlapping text will be rendered too slow
    afterChange: (currentIndex: number) => {
      const itemId = items[currentIndex].id;
      setSliderIndex(currentIndex);
      onChangeSliderItem?.(itemId);
    },
  };

  return (
    <SkeletonGroup
      isReady={!loading && !!items.length}
      placeholder={<HeroSkeleton />}
    >
      <StyledSliderContainer __css={styles.sliderContainer(dotsColor)}>
        <Slider {...sliderSettings}>
          {items.map((item, idx) => {
            return (
              <Hero
                key={idx}
                data={item}
                onViewCollectionClick={onViewCollectionClick}
                onOpenVideoPlayer={onOpenVideoPlayer}
                customWrapperStyles={customWrapperStyles}
              />
            );
          })}
        </Slider>
      </StyledSliderContainer>
    </SkeletonGroup>
  );
};
